import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { TimelineEventVM } from "@shared-kernel/application/ports/admin/admin-repository";

export const retrieveTimelineEvents = createAsyncThunk<TimelineEventVM[], string, { extra: Partial<Dependencies> }>(
  "timelineEvents/retrieveTimelineEvents",
  async (targetedUserId: string, { extra: { adminRepository } }) => {
    return adminRepository!.listTimelineEvents(targetedUserId);
  },
);
